export enum RecipientStatus {
    UNCONFIRMED,
    CONFIRMED,
    WaitingForAdminApproval,
    INVITED,
}


export const getStatusLabel = (status: number) => {
    switch (status) {
        case RecipientStatus.UNCONFIRMED: return 'Unconfirmed';
        case RecipientStatus.CONFIRMED: return 'Confirmed';
        case RecipientStatus.WaitingForAdminApproval: return 'Under Review'; // NIWD-560
        case RecipientStatus.INVITED: return 'Invited';
        default: return '';
    }
};

export enum GiftorStatus {
    Unconfirmed ,
    Confirmed ,
}
